import * as React from "react";

import { cn } from "@replohq/lattice/utils/cn";
import { useReducedMotion } from "motion/react";

import {
  BETA_INTRO_ANIMATED_PREVIEW_URL,
  BETA_INTRO_VIDEO_THUMBNAIL_URL,
} from "../betaIntroVideo";

export function BetaIntroThumbnail({
  className,
  imageClassName,
  onClick,
}: {
  className?: string;
  imageClassName?: string;
  onClick: () => void;
}) {
  const shouldReduceMotion = useReducedMotion();

  return (
    <button
      type="button"
      aria-label="Watch Yuxin demo the new Replo"
      data-beta-intro-thumbnail
      onClick={onClick}
      className={cn(
        "relative block aspect-video cursor-pointer overflow-hidden bg-default outline-none ring-inset ring-focus transition-[opacity,transform] duration-fast hover:opacity-90 active:scale-[0.99] focus-visible:ring-2 motion-reduce:transition-none",
        className,
      )}
    >
      <img
        alt=""
        src={
          shouldReduceMotion
            ? BETA_INTRO_VIDEO_THUMBNAIL_URL
            : BETA_INTRO_ANIMATED_PREVIEW_URL
        }
        className={cn("size-full object-contain", imageClassName)}
        decoding="async"
        draggable={false}
        referrerPolicy="no-referrer"
      />
    </button>
  );
}
